export default {
  productName: 'Stories',
  common: {
    back: 'Back',
  },
  pages: {
    landing: {
      start: 'Start!',
    },
    login: {
      error: 'Login failed. Please try again.',
    },
    error404: {
      pageNotFound: 'Page not found!',
    },
    intro: {
      titles: ['Read Anytime, Anywhere', 'Premium Content', 'Age-Based Discovery'],
      descriptions: [
        'Enjoy high-quality stories designed for children of all ages.',
        'Access a growing library of exclusive content for your children.',
        "Find the perfect stories based on your child's age and interests.",
      ],
      next: 'Next',
      getStarted: 'Get Started!',
      skip: 'Skip',
    },
  },
  components: {
    authentication: {
      magiclink: {
        welcome: 'Log in to your account',
        sendLink: 'Send Magic Link',
        verify: 'Verify',
        backToLogin: 'Back to login',
        error: {
          generic: 'Something went wrong. Please try again.',
          invalid: 'Invalid email or request.',
          throttled: 'Too many requests. Please wait and try again.',
          unknown: 'An error occurred. Please try again later.',
        },
      },
    },
    mainUserBanner: {
      welcome: 'Welcome back, {name}',
      searchPlaceholder: 'Search for a book...',
      crystals: 'Crystals',
      booksCompleted: 'Books Completed',
    },
    mainFooter: {
      copyright: '©2026 THE CARROT CORPORATION LTD. All rights reserved.',
    },
  },
};
